import { reflect } from '@effector/reflect'

import { modalOpener } from '@/shared/ui/modal'

import * as model from './model'
import { MessageReportDialog as View } from './view'

export const MessageReportDialog = {
    View: reflect({
        view: View,
        bind: {
            step: model.$step,
            onReportReasonClick: model.reportReasonClicked,
            onReportButtonClick: model.reportButtonClicked,
            onBackButtonClick: model.backButtonClicked,
            nonInteractive: model.$interactionDisabled,
        },
    }),
    model,
}

model.showFx.use(modalOpener(MessageReportDialog.View))
